// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Category = require("../Control.Category/index.js");
var Control_Monad_State_Class = require("../Control.Monad.State.Class/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Boolean = require("../Data.Boolean/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Monoid = require("../Data.Monoid/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_String_CodeUnits = require("../Data.String.CodeUnits/index.js");
var Data_String_Common = require("../Data.String.Common/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Data_Unit = require("../Data.Unit/index.js");
var Halogen_HTML_Core = require("../Halogen.HTML.Core/index.js");
var Halogen_HTML_Elements = require("../Halogen.HTML.Elements/index.js");
var Halogen_HTML_Events = require("../Halogen.HTML.Events/index.js");
var Halogen_HTML_Properties = require("../Halogen.HTML.Properties/index.js");
var Halogen_Query_HalogenM = require("../Halogen.Query.HalogenM/index.js");
var Lunarbox_Component_Dropdown = require("../Lunarbox.Component.Dropdown/index.js");
var Lunarbox_Component_Utils = require("../Lunarbox.Component.Utils/index.js");
var Lunarbox_Data_String = require("../Lunarbox.Data.String/index.js");
var Select = require("../Select/index.js");
var Select_Setters = require("../Select.Setters/index.js");
var GetAvailableItems = (function () {
    function GetAvailableItems(value0) {
        this.value0 = value0;
    };
    GetAvailableItems.create = function (value0) {
        return new GetAvailableItems(value0);
    };
    return GetAvailableItems;
})();
var Clear = (function () {
    function Clear(value0) {
        this.value0 = value0;
    };
    Clear.create = function (value0) {
        return new Clear(value0);
    };
    return Clear;
})();
var SelectionsChanged = (function () {
    function SelectionsChanged(value0) {
        this.value0 = value0;
    };
    SelectionsChanged.create = function (value0) {
        return new SelectionsChanged(value0);
    };
    return SelectionsChanged;
})();
var Remove = (function () {
    function Remove(value0) {
        this.value0 = value0;
    };
    Remove.create = function (value0) {
        return new Remove(value0);
    };
    return Remove;
})();
var spec$prime = function (dictMonadAff) {
    return function (dictFunctor) {
        return function (dictMonoid) {
            return function (dictShow) {
                return function (dictEq) {
                    return function (select$prime) {
                        return function (remove$prime) {
                            return function (filter$prime) {
                                return function (render$prime) {
                                    var handleQuery = function (v) {
                                        if (v instanceof Clear) {
                                            return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify(Halogen_Query_HalogenM.monadStateHalogenM)(function (st) {
                                                var $29 = {};
                                                for (var $30 in st) {
                                                    if ({}.hasOwnProperty.call(st, $30)) {
                                                        $29[$30] = st[$30];
                                                    };
                                                };
                                                $29.selected = Data_Monoid.mempty(dictMonoid);
                                                $29.available = st.items;
                                                $29.search = "";
                                                return $29;
                                            }))(function (st) {
                                                return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Halogen_Query_HalogenM.raise(new SelectionsChanged(st.selected)))(function () {
                                                    return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(new Data_Maybe.Just(v.value0));
                                                });
                                            });
                                        };
                                        if (v instanceof GetAvailableItems) {
                                            return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (st) {
                                                return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Maybe.Just.create(v.value0(st.available)));
                                            });
                                        };
                                        throw new Error("Failed pattern match at Lunarbox.Component.Typeahead (line 227, column 17 - line 234, column 35): " + [ v.constructor.name ]);
                                    };
                                    var handleEvent = function (v) {
                                        if (v instanceof Select.Searched) {
                                            return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (st) {
                                                var fixCase = function (a) {
                                                    if (Lunarbox_Data_String.hasUppercase(a)) {
                                                        return Control_Category.identity(Control_Category.categoryFn);
                                                    };
                                                    if (Data_Boolean.otherwise) {
                                                        return Data_String_Common.toLower;
                                                    };
                                                    throw new Error("Failed pattern match at Lunarbox.Component.Typeahead (line 207, column 9 - line 209, column 39): " + [ a.constructor.name ]);
                                                };
                                                var items = Data_Array.filter((function () {
                                                    var $64 = Data_String_CodeUnits.contains(v.value0);
                                                    var $65 = fixCase(v.value0);
                                                    var $66 = Data_Show.show(dictShow);
                                                    return function ($67) {
                                                        return $64($65($66($67)));
                                                    };
                                                })())(st.items);
                                                return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                                                    var $36 = {};
                                                    for (var $37 in v1) {
                                                        if ({}.hasOwnProperty.call(v1, $37)) {
                                                            $36[$37] = v1[$37];
                                                        };
                                                    };
                                                    $36.available = filter$prime(items)(st.selected);
                                                    return $36;
                                                });
                                            });
                                        };
                                        if (v instanceof Select.Selected) {
                                            return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (st) {
                                                var selected$prime = select$prime(v.value0)(st.available)(st.selected);
                                                return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                                                    var $40 = {};
                                                    for (var $41 in v1) {
                                                        if ({}.hasOwnProperty.call(v1, $41)) {
                                                            $40[$41] = v1[$41];
                                                        };
                                                    };
                                                    $40.selected = selected$prime;
                                                    $40.available = filter$prime(st.available)(selected$prime);
                                                    $40.visibility = Select.Off.value;
                                                    return $40;
                                                }))(function () {
                                                    return Halogen_Query_HalogenM.raise(new SelectionsChanged(selected$prime));
                                                });
                                            });
                                        };
                                        return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Unit.unit);
                                    };
                                    var handleAction = function (v) {
                                        return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (st) {
                                            var selected$prime = remove$prime(v.value0)(st.selected);
                                            return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                                                var $45 = {};
                                                for (var $46 in v1) {
                                                    if ({}.hasOwnProperty.call(v1, $46)) {
                                                        $45[$46] = v1[$46];
                                                    };
                                                };
                                                $45.selected = selected$prime;
                                                $45.available = filter$prime(st.items)(selected$prime);
                                                return $45;
                                            }))(function () {
                                                return Halogen_Query_HalogenM.raise(new SelectionsChanged(selected$prime));
                                            });
                                        });
                                    };
                                    return {
                                        render: render$prime,
                                        handleAction: handleAction,
                                        handleQuery: handleQuery,
                                        handleEvent: handleEvent,
                                        receive: Select.defaultSpec.receive,
                                        initialize: Select.defaultSpec.initialize,
                                        finalize: Select.defaultSpec.finalize
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
var remove = function ($68) {
    return Select.Action.create(Remove.create($68));
};
var single = function (dictMonadAff) {
    return function (dictShow) {
        return function (dictEq) {
            return function (dictSemigroup) {
                var render = function (st) {
                    if (st.selected instanceof Data_Maybe.Just) {
                        return Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className((function () {
                            var $50 = Data_Eq.eq(Select.eqVisibility)(st.visibility)(Select.On.value);
                            if ($50) {
                                return "dropdown dropdown--is-active";
                            };
                            return "dropdown dropdown--is-flex";
                        })()) ])([ Lunarbox_Component_Dropdown.toggle(dictShow)([ Halogen_HTML_Events.onClick(function (v) {
                            return Data_Maybe.Just.create(remove(st.selected.value0));
                        }) ])(st), Lunarbox_Component_Dropdown.menu(dictShow)(st) ]);
                    };
                    if (st.selected instanceof Data_Maybe.Nothing) {
                        return Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className((function () {
                            var $52 = Data_Eq.eq(Select.eqVisibility)(st.visibility)(Select.On.value);
                            if ($52) {
                                return "dropdown dropdown--is-flex dropdown--is-active";
                            };
                            return "dropdown dropwdown--is-flex";
                        })()) ])([ Halogen_HTML_Elements.input(Select_Setters.setInputProps([ Halogen_HTML_Properties.placeholder(st.placeholder), Halogen_HTML_Properties.value(st.search), Lunarbox_Component_Utils.className("dropdown__typeahead-input form__field form__field--text") ])), Lunarbox_Component_Dropdown.menu(dictShow)(st) ]);
                    };
                    throw new Error("Failed pattern match at Lunarbox.Component.Typeahead (line 103, column 15 - line 133, column 10): " + [ st.selected.constructor.name ]);
                };
                var filter$prime = function (items) {
                    return function (v) {
                        if (v instanceof Data_Maybe.Nothing) {
                            return items;
                        };
                        if (v instanceof Data_Maybe.Just) {
                            return Data_Array.filter(function (v1) {
                                return Data_Eq.eq(dictEq)(v1)(v.value0);
                            })(items);
                        };
                        throw new Error("Failed pattern match at Lunarbox.Component.Typeahead (line 99, column 3 - line 99, column 32): " + [ items.constructor.name, v.constructor.name ]);
                    };
                };
                return spec$prime(dictMonadAff)(Data_Maybe.functorMaybe)(Data_Maybe.monoidMaybe(dictSemigroup))(dictShow)(dictEq)(function (i) {
                    return function (av) {
                        return Data_Function["const"](Data_Array.index(av)(i));
                    };
                })(Data_Function["const"](Data_Function["const"](Data_Maybe.Nothing.value)))(filter$prime)(render);
            };
        };
    };
};
var multi = function (dictMonadAff) {
    return function (dictShow) {
        return function (dictEq) {
            var selectByIndex = function (ix) {
                return function (available) {
                    return function (selected) {
                        var v = Data_Array.index(available)(ix);
                        if (v instanceof Data_Maybe.Nothing) {
                            return selected;
                        };
                        if (v instanceof Data_Maybe.Just) {
                            return Data_Array.cons(v.value0)(selected);
                        };
                        throw new Error("Failed pattern match at Lunarbox.Component.Typeahead (line 143, column 41 - line 145, column 33): " + [ v.constructor.name ]);
                    };
                };
            };
            var render = function (st) {
                return Halogen_HTML_Elements.div_([ Halogen_HTML_Elements.div([ (function () {
                    var $58 = Data_Array.length(st.selected) > 0;
                    if ($58) {
                        return Lunarbox_Component_Utils.className("panel is-marginless");
                    };
                    return Lunarbox_Component_Utils.className("panel is-hidden");
                })() ])(Data_Functor.mapFlipped(Data_Functor.functorArray)(st.selected)(function (i) {
                    return Halogen_HTML_Elements.div([ Halogen_HTML_Events.onClick(function (v) {
                        return Data_Maybe.Just.create(remove(i));
                    }) ])([ Halogen_HTML_Core.text(Data_Show.show(dictShow)(i)) ]);
                })), Halogen_HTML_Elements.div([ (function () {
                    var $59 = Data_Eq.eq(Select.eqVisibility)(st.visibility)(Select.On.value);
                    if ($59) {
                        return Lunarbox_Component_Utils.className("dropdown is-flex is-active");
                    };
                    return Lunarbox_Component_Utils.className("dropdown is-flex");
                })() ])([ Halogen_HTML_Elements.input(Select_Setters.setInputProps([ Lunarbox_Component_Utils.className("form__field form__field--text"), Halogen_HTML_Properties.placeholder(st.placeholder), Halogen_HTML_Properties.value(st.search) ])), Lunarbox_Component_Dropdown.menu(dictShow)(st) ]) ]);
            };
            return spec$prime(dictMonadAff)(Data_Functor.functorArray)(Data_Monoid.monoidArray)(dictShow)(dictEq)(selectByIndex)((function () {
                var $69 = Data_Eq.notEq(dictEq);
                return function ($70) {
                    return Data_Array.filter($69($70));
                };
            })())(Data_Array.difference(dictEq))(render);
        };
    };
};
var input = function (dictMonoid) {
    return function (v) {
        return {
            inputType: Select.Text.value,
            search: Data_Maybe.Nothing.value,
            debounceTime: Data_Maybe.Nothing.value,
            getItemCount: function ($71) {
                return Data_Array.length((function (v1) {
                    return v1.items;
                })($71));
            },
            selected: v.selected,
            available: v.items,
            items: v.items,
            placeholder: v.placeholder
        };
    };
};
var getAvailableItems = function ($72) {
    return Select.Query.create(GetAvailableItems.create($72));
};
var clear = new Select.Query(new Clear(Data_Unit.unit));
var _typeaheadSingle = Data_Symbol.SProxy.value;
var _typeaheadMulti = Data_Symbol.SProxy.value;
var _typeahead = Data_Symbol.SProxy.value;
module.exports = {
    GetAvailableItems: GetAvailableItems,
    Clear: Clear,
    SelectionsChanged: SelectionsChanged,
    Remove: Remove,
    "_typeahead": _typeahead,
    "_typeaheadSingle": _typeaheadSingle,
    "_typeaheadMulti": _typeaheadMulti,
    "spec'": spec$prime,
    single: single,
    multi: multi,
    input: input
};
